// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__bY77Q","addWidgetButton":"Header_addWidgetButton__xxM6l","dashboardTabs":"Header_dashboardTabs__3bzQB","active":"Header_active__3r0m2"};